import GlobalSearchState, {
	ContentSearchBlock,
	GlobalSearchMode,
	GlobalSearchScope,
	MultiSearch,
	SearchBlockOperator,
	SearchBlockOpType,
	SearchBlockType
} from "../../typings";

export default class Utils {
	public static compareCaseInsensitive(s1: string, s2: string): number {
		return s1.localeCompare(s2, undefined, { sensitivity: "base" });
	}

	public static searchBlockOperators: SearchBlockOperator[] = [];

	public static translatedOperators: Record<string, string> = {};

	public static isBoolOperator(type: number): boolean {
		return type === SearchBlockOpType.NOT ||
			type === SearchBlockOpType.AND ||
			type === SearchBlockOpType.OR;
	}

	public static isGlobalSearchDialogEvent(e: JQueryKeyEventObject): boolean {
		return $(e.target).closest(".ui-dialog").length > 0 ||
			$(document).has(".ui-widget-overlay").length > 0;
	}

	public static getOperatorLike(value: string): SearchBlockOperator {
		return Utils.searchBlockOperators.filter(
			block => Utils.compareCaseInsensitive(block.text.substring(0, value.length), value) === 0)[0];
	}

	public static getOperator(value: string): SearchBlockOperator {
		return Utils.searchBlockOperators.filter(block => block.jsEquivalent == value || Utils.compareCaseInsensitive(block.name, value) === 0)[0];
	}

	public static createSearchBlockOperator(operator: { 
		name: string, type: number, jsEquivalent: string, special: boolean }): SearchBlockOperator {
		const searchBlock: SearchBlockOperator = 
			{ ...operator, text: operator.special ? operator.jsEquivalent : operator.name };
		return searchBlock;
	}

	public static getOperatorName(opType: SearchBlockOpType): string {
		switch (opType) {
			case SearchBlockOpType.AND:
				return "AND";
			case SearchBlockOpType.OR:
				return "OR";
			case SearchBlockOpType.NOT:
				return "NOT";
			case SearchBlockOpType.LeftParens:
				return "(";
			case SearchBlockOpType.RightParens:
				return ")";
		}

		return "";
	}

	public static termsToLogString(terms: ContentSearchBlock[]): string {
		const blocks = terms?.length ? terms : terms ? [terms] : [];
		let resultPhrase = "";
		$.each(blocks, (index, value: ContentSearchBlock) => {
			if (!value) {
				return;
			}

			if (resultPhrase) {
				resultPhrase += " ";
			}

			if (value.type === SearchBlockType.Operator) {
				resultPhrase += `[[${Utils.getOperatorName(value.opType)}]]`;
				return;
			}

			const descriptorId = value.descriptor?.descriptorId ?? 0;
			const vocabularyId = value.descriptor?.vocabularyId ?? 0;

			resultPhrase += `${value.text}|D:${descriptorId}|V:${vocabularyId}`;
		});

		return resultPhrase;
	}

	public static getAnalyticSearchMode(state: GlobalSearchState): string {
		if (state.selectedSideItemValue === MultiSearch.EDS && state.searchScope !== GlobalSearchScope.MyLibrary) {
			return "eds";
		}

		switch (state.searchMode) {
			case GlobalSearchMode.SemanticSearch:
				return "semantic";
			case GlobalSearchMode.FullText:
				return "fulltext";
		}

		return "default";
	}

	private static _initialize = (function() {
		Utils.searchBlockOperators[SearchBlockOpType.AND] = Utils.createSearchBlockOperator(
			{ name: GlobalSearchState.andOperatorText, type: SearchBlockOpType.AND, jsEquivalent: "&&", special: false });
		Utils.searchBlockOperators[SearchBlockOpType.OR] = Utils.createSearchBlockOperator(
			{ name: GlobalSearchState.orOperatorText, type: SearchBlockOpType.OR, jsEquivalent: "||", special: false });
		Utils.searchBlockOperators[SearchBlockOpType.NOT] = Utils.createSearchBlockOperator(
			{ name: GlobalSearchState.notOperatorText, type: SearchBlockOpType.NOT, jsEquivalent: "!", special: false });
		Utils.searchBlockOperators[SearchBlockOpType.LeftParens] = Utils.createSearchBlockOperator(
			{ name: GlobalSearchLabels.LeftParenOperator, type: SearchBlockOpType.LeftParens, jsEquivalent: "(", special: true });
		Utils.searchBlockOperators[SearchBlockOpType.RightParens] = Utils.createSearchBlockOperator(
			{ name: GlobalSearchLabels.RightParenOperator, type: SearchBlockOpType.RightParens, jsEquivalent: ")", special: true });

		Utils.translatedOperators[GlobalSearchState.andOperatorText] = GlobalSearchLabels.AndOperator;
		Utils.translatedOperators[GlobalSearchState.orOperatorText] = GlobalSearchLabels.OrOperator;
		Utils.translatedOperators[GlobalSearchState.notOperatorText] = GlobalSearchLabels.NotOperator;
	})();
}
